'use client'

import styled from 'styled-components'

import { PageSectionContent } from '../../PageSection.client'

export const ContentfulPageTitleSectionContent = styled(PageSectionContent)`
  text-align: center;
`
